import React, { Component } from 'react'
import { Grid, Cell } from 'react-mdl'
import Education from './education';
import Education1 from './education1';
import Skills from './skills';
class resume extends Component {
    render() {
        return (
            <div>
                <Grid>
                    <Cell col={4}>
                        <div style={{textAlign:'center'}}>
                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSr1OGM_q7SNDpz7NBUp_3LjldGAN5WubFscg&usqp=CAU" alt="avatar" style={{height:'200px',paddingRight:'100px',paddingTop:'20px'}}/>
                        </div>
                        <h2 style={{paddingTop:'0em'}}>Chakka Yamini</h2>
                        <h4 style={{color:'grey'}}>Full Stack Developer</h4>
                        <hr style={{borderTop:'3px solid #833fb2',width:'50%'}}/>
                        <p style={{display:'center'}}>Hi I am Yamini an Optimistic,Quick Learner and interested in exploring about new things and makings friends.</p>
                        <hr style={{borderTop:'3px solid #833fb2',width:'50%'}}/>
                        <h5>Address</h5>
                        <p>1-58/1,Bhadradhi Kothagudem</p>
                        <h5>Phone</h5>
                        <p>9705163493</p>
                        <h5>Email</h5>
                        <p>yaminikanakarao@gmail.com</p>
                        <hr style={{borderTop:'3px solid #833fb2',width:'50%'}}/>
                    </Cell>
                    <Cell className="resume-right-col"col={8}>
                        <h2>Education</h2>
                        <Education1
                        startYear={2014}
                        schoolName="Kakatiya High School"
                        schoolDescription="CGPA - 9.5"
                        />
                        <Education
                        startYear={2014}
                        endYear={2016}
                        schoolName="Nalanda Junior COllege"
                        schoolDescription="98.5%"
                        />
                        <Education
                        startYear={2016}
                        endYear={2020}
                        schoolName="Sreenidhi Institute of Science and Technology"
                        Course="Bachelor of Technology - B.Tech"
                        Stream="Computer Science and Engineering - CSE"
                        schoolDescription="CGPA - 9.59"
                        />
                        <hr style={{borderTop:'3px solid #e22947'}}/>
                        <h2>Skills</h2>
                        <Grid>
                        <Skills />
                        </Grid>
                    </Cell>
                </Grid>
            </div>
        )
    }
}

export default resume;
